const getButtonSidePanelFiltersStyles = theme => ({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingBottom: theme.spacing(2),
  marginTop: 0,
  flexGrow: 1,
  [theme.mediaQuery('tabletLarge')]: {
    marginTop: 0
  }
});

export { getButtonSidePanelFiltersStyles };
//# sourceMappingURL=SidePanelFiltersStyles.js.map
